function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { PureComponent, createElement } from 'react';
import { debounce } from '@finect/front-utils/debounce';
var TextEllipsis = function (_PureComponent) {
  _inherits(TextEllipsis, _PureComponent);
  var _super = _createSuper(TextEllipsis);
  function TextEllipsis(props) {
    var _this;
    _classCallCheck(this, TextEllipsis);
    _this = _super.call(this, props);
    _this.isSupportNativeClamp = false;
    _this.truncate = _this.truncate.bind(_assertThisInitialized(_this));
    _this.process = _this.process.bind(_assertThisInitialized(_this));
    _this.debounceProcess = debounce(_this.process, _this.props.debounceTimeoutOnResize);
    _this.text = '';
    _this.lineHeight = 0;
    _this.splitOnChars = ['.', '-', '–', '—', ' '];
    _this.splitChar = _this.splitOnChars[0];
    _this.chunks = null;
    _this.lastChunk = null;
    return _this;
  }
  _createClass(TextEllipsis, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isSupportNativeClamp = this.props.useJsOnly ? false : 'webkitLineClamp' in document.body.style;
      this.text = this.container.innerHTML;
      this.process();
      window.addEventListener('resize', this.debounceProcess, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.text = this.container.innerHTML;
      this.process();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debounceProcess, false);
    }
  }, {
    key: "onResult",
    value: function onResult() {
      if (this.container.scrollWidth > this.container.clientWidth || this.container.scrollHeight > this.container.clientHeight) {
        this.props.onResult(TextEllipsis.RESULT.TRUNCATED);
      } else {
        this.props.onResult(TextEllipsis.RESULT.NOT_TRUNCATED);
      }
    }
  }, {
    key: "getLineHeight",
    value: function getLineHeight() {
      var lineHeight = this.computedStyle('line-height');
      if (lineHeight === 'normal') {
        return Math.ceil(parseFloat(this.computedStyle('font-size')) * 1.2);
      }
      return Math.ceil(parseFloat(lineHeight));
    }
  }, {
    key: "truncate",
    value: function truncate() {
      if (!this.chunks) {
        if (this.splitOnChars.length > 0) {
          this.splitChar = this.splitOnChars.shift();
        } else {
          this.splitChar = '';
        }
        this.chunks = this.container.innerHTML.split(this.splitChar);
      }
      if (this.chunks.length > 1) {
        this.lastChunk = this.chunks.pop();
        this.container.innerHTML = this.chunks.join(this.splitChar) + this.props.ellipsisChars;
      } else {
        this.chunks = null;
      }
      if (this.chunks) {
        if (this.container.offsetHeight <= this.lineHeight * this.props.lines) {
          if (this.splitOnChars.length >= 0 && this.splitChar !== '') {
            this.container.innerHTML = this.chunks.join(this.splitChar) + this.splitChar + this.lastChunk;
            this.chunks = null;
          } else {
            return;
          }
        }
      } else if (this.splitChar === '') {
        return;
      }
      this.truncate();
    }
  }, {
    key: "process",
    value: function process() {
      if (this.isSupportNativeClamp) {
        var _this$container;
        var sty = (_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.style;
        if (!sty) return;
        sty.overflow = 'hidden';
        sty.textOverflow = 'ellipsis';
        sty.webkitBoxOrient = 'vertical';
        sty.display = '-webkit-box';
        sty.webkitLineClamp = this.props.lines;
        this.onResult();
      } else {
        this.lineHeight = this.getLineHeight();
        if (this.container.offsetHeight < this.lineHeight * this.props.lines) {
          this.onResult();
        } else {
          this.truncate();
        }
      }
    }
  }, {
    key: "computedStyle",
    value: function computedStyle(name) {
      return document.defaultView.getComputedStyle(this.container, null).getPropertyValue(name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return createElement(this.props.tag, {
        ref: function ref(node) {
          _this2.container = node;
        },
        className: this.props.tagClass,
        style: Object.assign({
          width: '100%',
          wordWrap: 'break-word'
        }, this.props.style)
      }, this.props.children);
    }
  }]);
  return TextEllipsis;
}(PureComponent);
TextEllipsis.RESULT = {
  TRUNCATED: 'TRUNCATED',
  NOT_TRUNCATED: 'NOT_TRUNCATED'
};
TextEllipsis.defaultProps = {
  tag: 'div',
  ellipsisChars: '...',
  tagClass: '',
  debounceTimeoutOnResize: 200,
  useJsOnly: false,
  style: {},
  onResult: function onResult() {}
};
export { TextEllipsis };